import styled from "styled-components";

export const InputWrapper = styled.div<{ isEditing?: boolean; isDisabled?: boolean }>`
    display: flex;
    ${({ isEditing }) => isEditing && "flex: 1"};
`;
